import { isEmpty } from 'lodash';
import { CustomerGroupFilter } from './model';
import { TreeInput } from '../filter/model';
import { mapDataToInputItems } from '../filter/helpers';

export const traverseFilterTree = (
  input: CustomerGroupFilter[],
  root?: string
): TreeInput[] => {
  const data: TreeInput[] = [];

  input.forEach(({ customerGroups, id, name, subFolders }) => {
    const subFoldersInput = traverseFilterTree(subFolders, root);
    const customerGroupsInput = mapDataToInputItems(
      customerGroups,
      'id',
      'name'
    );
    const childrenData = [...subFoldersInput, ...customerGroupsInput];
    if (!isEmpty(childrenData) && !isEmpty(name)) {
      if (name !== root) {
        data.push({
          id,
          value: name,
          TreeData: childrenData,
          selected: false,
        });
      } else {
        data.push(...childrenData);
      }
    }
  });
  return data;
};
